// client/src/api/academiaApi.js
import axios from 'axios';

// Register a new academia and user
const registerAcademia = async (formData, config) => {
  try {
    const formDataObj = {};
    for (let [key, value] of formData.entries()) {
      formDataObj[key] = value;
    }

    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await axios.post(`/api/academias`, formData, {
      ...config,
      validateStatus: function (status) {
        return status < 500;
      }
    });

    if (response.data && response.data.token) {
      localStorage.setItem('token', response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error('Registration error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      statusText: error.response?.statusText,
      headers: error.response?.headers,
      config: error.config
    });

    throw error.response?.data || { message: error.message };
  }
};

// Get academia profile
const getAcademiaProfile = async (academiaId) => {
  try {
    const response = await axios.get(`/api/academia/${academiaId}`);
    
    if (response.data.success) {
      return response.data.data;
    }
    return response.data;
  } catch (error) {
    console.error('Error fetching academia profile:', error);
    throw error.response?.data || error.message;
  }
};

// Update academia profile
const updateAcademiaProfile = async (academiaId, formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await axios.put(`/api/academia/${academiaId}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default {
  registerAcademia,
  getAcademiaProfile,
  updateAcademiaProfile
};
